import { JwtTokenErrorEnum, JWT_TOKEN_NEST_TRADER_ERROR, JWT_TOKEN_NEST_TRADER_HIDE_ERROR, JWT_TOKEN_NEST_TRADER_SHIMMER, } from "./JwtTokenNestReducer";
import { jwtTokenFetchUseCase } from "../../components/Reports/HoldingReports/di/servicelocator";
export const JwtTokenNestThunk = (requestData) => async (dispatch, getState) => {
    dispatch({
        type: JWT_TOKEN_NEST_TRADER_SHIMMER,
        payload: {
            showShimmer: true
        }
    });
    dispatch({
        type: JWT_TOKEN_NEST_TRADER_HIDE_ERROR,
        errorType: JwtTokenErrorEnum.ERROR_DATA,
    });
    jwtTokenFetchUseCase.execute({
        onSuccess: (data) => {
            localStorage.removeItem("isImpersonated");
            localStorage.setItem("jwt_token", data !== null ? data : localStorage.getItem("jwt_token"));
            dispatch({
                type: JWT_TOKEN_NEST_TRADER_SHIMMER,
                payload: {
                    showShimmer: false
                }
            });
        },
        onError: (error) => {
            // error action
            dispatch({
                type: JWT_TOKEN_NEST_TRADER_ERROR,
                payload: {
                    errorData: error,
                },
                errorType: JwtTokenErrorEnum.ERROR_DATA,
            });
            dispatch({
                type: JWT_TOKEN_NEST_TRADER_SHIMMER,
                payload: {
                    showShimmer: false
                }
            });
        },
    }, requestData);
    //    dispatch({ type: "Update account details", payload: accountData });
};
